/**
 * Drop a transaction from a cached list response.
 *
 * Used after a dismiss so the row leaves the unmatched list immediately, instead of
 * refetching and waiting on the search index. Operates on the raw API response, which is
 * what SWR caches; DataTableWithBackendSearch re-derives its display fields from it.
 *
 * @param {object} response cached response: { total, transactions }
 * @param {string} id       the transaction that was dismissed
 * @returns {object} a new response object, or the original when the row is not in it
 */
export const removeTransactionFromList = (response, id) => {
    if (!response || !id) return response;

    const transactions = response.transactions || [];
    const remaining = transactions.filter(transaction => transaction.id !== id);
    if (remaining.length === transactions.length) return response;

    return {
        ...response,
        // Guard the subtraction rather than trusting `total` to agree with the rows we
        // hold: the count comes from the search layer and the page we have is one slice.
        ...(typeof response.total === 'number' ? { total: Math.max(0, response.total - 1) } : {}),
        transactions: remaining,
    };
};
